/**
 * Preview Environment Banner
 * Shows a notice that this is an internal preview environment
 */
import React, { useState } from 'react';
import { X, AlertTriangle } from 'lucide-react';

export function PreviewBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="bg-amber-500 text-white px-4 py-2 text-sm flex items-center justify-between">
      <div className="flex items-center gap-2">
        <AlertTriangle className="w-4 h-4" />
        <span className="font-medium">Internal Preview Environment</span>
        <span className="hidden sm:inline">- Test Data Only | No Real Payments | Demo Purposes</span>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="p-1 hover:bg-amber-600 rounded"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
